module.exports = __webpack_public_path__ + "static/media/virtualEvents.e1a366ec.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/virtualEvents.gif
// module id = 122
// module chunks = 1